import React from "react";

export const BenefitsAdvantages = () => (
  <>
    <div className="hero">
      <h1>Benefit & Advantages</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column fadeLeftMini">
          <h2>Customer</h2>
          <h6>Convenience:</h6>
          <p>
            Enjoy the convenience of having your car cleaned and polished
            wherever you are, eliminating the need to visit a traditional car
            wash or detailing service.
          </p>
          <h6>Time-saving:</h6>
          <p>
            Our mobile service saves you time by coming to you, so you don't
            have to travel or wait for your car to be cleaned.
          </p>
          <h6>Premium PureShield Technology:</h6>
          <p>
            Advanced ceramic coating and SiO2 protection systems provide superior 
            paint protection, gloss enhancement, and long-term vehicle value 
            preservation through professional-grade waterless application.
          </p>
          <h6>Water-saving:</h6>
          <p>
            Our waterless cleaning method conserves more water than traditional
            techniques, promoting environmental sustainability.
          </p>
          <h6>Comprehensive Service Range:</h6>
          <p>
            Premium services include waterless wash (£25-£90), ceramic coating (£150-£330), 
            mobile ozone odour removal (£50+), fleet cleaning, delivered across Surrey & 
            Greater London operational area. Over 1034 cars serviced and growing.
          </p>
          <h6>Premium Value Positioning:</h6>
          <p>
            Services positioned at premium market rates (£25-£330) reflecting 
            advanced technology, zero-carbon credentials, and professional 
            mobile convenience.
          </p>
          <h6>Professionalism:</h6>
          <p>
            Our professional and well-presented mobile service instills
            confidence in the quality of service you will receive.
          </p>
          <h6>Flexibility:</h6>
          <p>
            Designed to fit around your busy schedule, our flexible service
            enhances overall customer satisfaction.
          </p>
        </div>
        <div className="column fadeRightMini">
          <h2>Investor</h2>
          <h6>Partnership-Based Growth Model:</h6>
          <p>
            18-month operational track record with established major retail partnership 
            and active fuel retailer negotiations providing immediate revenue potential 
            with investment funding.
          </p>
          <h6>Technology Differentiation:</h6>
          <p>
            Zero-carbon waterless technology and PureShield ceramic protection 
            provide competitive advantages in growing eco-conscious automotive 
            care market segment.
          </p>
          <h6>B2B Partnership Focus:</h6>
          <p>
            Established partnerships with major retailers and ongoing fuel 
            retailer negotiations demonstrate B2B market validation and 
            scalable revenue potential.
          </p>
          <h6>Low Overhead:</h6>
          <p>
            Lower overhead costs compared to traditional car washes lead to
            higher profit margins for investors.
          </p>
          <h6>Eco-Friendly Approach:</h6>
          <p>
            Our waterless service is both eco-friendly and cost-efficient,
            aligning with consumer demand for environmentally friendly services.
          </p>
          <h6>Investment Return Potential:</h6>
          <p>
            Conservative revenue projections (£50k-£80k Year 1, £200k-£300k Year 3) 
            with established partnerships provide clear path to investment returns.
          </p>
          <h6>High-Profit Margin:</h6>
          <p>
            Our mobile service typically offers high-profit margins due to low
            overhead and high demand for convenience.
          </p>
          <h6>Early-Stage Entry Advantage:</h6>
          <p>
            Investment opportunity in proven business model with established 
            partnerships at early-stage valuation before significant scaling 
            and market expansion.
          </p>
        </div>
      </div>
    </section>
  </>
);
